var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('div',{staticClass:"py-10 secondary page-home-catalogs",class:!_vm.xs ? 'px-3' : ''},[_c('owl-carousel',{attrs:{"auto-width":true,"nav":false,"margin":30,"center":_vm.xs}},_vm._l((_vm.items),function(ref,i){
var img = ref.img;
var title = ref.title;
var to = ref.to;
return _c('v-card',{key:i,attrs:{"to":to,"width":"300px","tile":"","flat":"","color":"transparent"}},[_c('img',{staticClass:"page-home-catalogs-img d-block",attrs:{"src":img}}),_c('div',{staticClass:"pa-2 pt-5 text-center"},[_vm._v(_vm._s(title))])])}),1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }